const analyticsPage = {
  en: {
    analytics: {
      title: 'Analytics',
      totalCount: 'Total {msg} locations',
      filterDataBtn: 'Filter data',
      clearBtn: 'Clear',
      reportData: 'This report generated for: ',
      reportDataExpanded: 'This report generated for {msg} location(s): ',
      moreData: 'and {msg} more',
      showLess: 'show less',
      errorMsg: 'Something went wrong'
    },
    patientsCard: {
      title: 'Patients',
    },
    erCard: {
      title: 'Emergency room (ER)',
      chartNotEREligible: 'Not ER eligible',
      chartER: 'ER',
      chartERAvoided: 'ER avoided',
    },
    superUsersCard: {
      title: 'Super users',
      subtitle: 'Users with the highest call request volumes',
      tab1Month: '1 month',
      tab3Months: '3 months',
      tab6Months: '6 months',
      tableHeaderCount: '#',
      tableHeaderNurses: 'Nurses',
      tableHeaderCommunity: 'Location',
      tableHeaderRequests: 'Requests',
      noResult: 'No super users',
    },
    numberOfVisitsCard: {
      title: 'Number of visits',
      filterByMonth: 'By months',
      filterByWeeks: 'By weeks',
      tab6Months: '6 months',
      tableHeaderCount: '#',
      tableHeaderNurses: 'Nurses',
      tableHeaderCommunity: 'Location',
      tableHeaderRequests: 'Location',
      weekLabel: 'Week {msg}',
      chartLabel: 'Visits',
    },
    visitDurationCard: {
      title: 'Visit duration',
    },
    TTRCard: {
      title: 'Total time to resolution (TTR)',
    },
    medianChart: {
      medianLabel: 'Median',
      mostCasesLabel: '95% (most of the cases)',
    },
    filterData: {
      allTitle: 'All',
      title: 'Filter by locations',
      subtitle: 'Total {msg} locations',
      applyBtn: 'Apply',
      backBtn: 'Back',
      tableHeaderCommunities: 'Locations',
    },
  },
}
export default analyticsPage
